/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number2Dark = () => (
	<>
		<circle cx="16" cy="16" r="16" fill="#002855" />
		<path
			d="M9.75 24.21C9.54 24.21 9.375 24.045 9.375 23.835V23.115C9.375 23.0175 9.4125 22.92 9.4875 22.8525L13.9725 18.3375C16.2225 16.065 17.055 14.4975 17.055 12.555C17.055 10.8825 16.095 9.88497 14.475 9.88497C12.9525 9.88497 11.91 10.7475 11.31 11.475C11.235 11.565 11.13 11.61 11.0175 11.61C10.9425 11.61 10.875 11.5875 10.8075 11.55L10.1625 11.115C10.005 11.01 9.9525 10.8 10.0425 10.6275C11.0175 8.80497 12.735 6.37497 16.4175 6.37497C19.665 6.37497 21.69 8.22747 21.69 11.2125C21.69 14.655 18.2175 17.34 14.865 19.935C14.775 20.01 14.6775 20.0775 14.5875 20.1525H17.7675C19.3575 20.1525 19.815 20.0625 20.94 17.9325C21.0075 17.805 21.135 17.73 21.27 17.73H21.99C22.095 17.73 22.2 17.775 22.2675 17.8575C22.335 17.94 22.3725 18.045 22.3575 18.15L21.6825 23.8875C21.66 24.075 21.5025 24.2175 21.3075 24.2175H9.75V24.21Z"
			fill="white"
		/>
	</>
);

export default Number2Dark;
